export { PLUGIN_KEY, PLUGIN_PRIORITY, AutoRowSize } from "./autoRowSize.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/autoRowSize/index.mjs
// module id = 1234
// module chunks = 1